// extracted by mini-css-extract-plugin
export var body = "text-module--body--hMZ3s";
export var headline = "text-module--headline--c6n4W";
export var intro = "text-module--intro--uMp+x";